import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/hooks/use-toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const dataTest = variant === "destructive" ? "toast-error" : variant === "success" ? "toast-success" : "toast"
        return (
          <Toast key={id} variant={variant} data-test={dataTest} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle data-test="toast-title">{title}</ToastTitle>}
              {description && (
                <ToastDescription data-test="toast-description">{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
